var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-chart-two",attrs:{"id":"flow-chart-two","width":"1100","height":"1400"}})
}
var staticRenderFns = []

export { render, staticRenderFns }